import axios from 'axios';

import queryString from 'query-string';

import HiCache from 'utils/cache';
import HiStance from 'utils/HiStance';
import { useAppStore } from 'store/modules/appStore';
import { useUserStore } from 'store/modules/userStore';
import genSign from 'utils/sign';
import { getVersion } from 'utils/version';
import { useT } from 'core/i18n';
import { getAppVersion } from 'web_v2/src/styles/theme';
// import { getSyncedTime } from 'utils/networkTime';

axios.defaults.timeout = 30000;
// @ts-ignore
axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8';

axios.defaults.withCredentials = true;

// 创建一个axios实例
let instance = axios.create({
    timeout: 50000, // 请求超时时间
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
    },
});

// 将 Object 转 str eg {a:1, b: 1} -> a=1&b=1
export function formatObjectToString(obj: any = {}, url: string, method: string) {
    let arr: any[] = [];
    if (url.indexOf('?') !== -1 && method === 'get') {
        const urlHash = url.split('?')[1];
        obj = { ...obj, ...queryString.parse(urlHash) };
    }
    const newArray = Object.keys(obj).sort();
    newArray.forEach(item => {
        arr.push(`${item}=${obj[item]}`);
    });
    return arr.join('&');
}

// Request
instance.interceptors.request.use(
    async (config: any) => {
        const appStore = useAppStore();

        const token = HiCache.getCache<string>(HiStance.TOKEN);
        const systemData = appStore.getSystemData;
        // const token = HiCache.getCache(HiStance.TOKEN)

        if (token ?? '' !== '') {
            config.headers.Authorization = 'Bearer ' + token;
        }

        if (config.url.includes('refreshToken')) {
            config.headers.Authorization = '';
        }

        const ua = navigator.userAgent;

        // 获取设备类型
        // const isMobile = /Mobile/.test(ua);
        // if (isMobile) {
        //     config.headers['device'] = 'H5';
        // } else {
        //     config.headers['device'] = 'Pc';
        // }
        config.headers['device'] = 'H5';
        config.headers['language'] = appStore.language || 'en';
        // config.headers['m'] = systemData?.aliasNum || 1;

        const version = getAppVersion();

        config.headers['version'] = version;

        // 公共参数
        let data: any = {
            // timestamp: new Date().getTime(),
        };
        if (!config.url.includes('/sport/sportApi/findMatchOddsList')) {
            if (config.method == 'post') {
                data = {
                    ...data,
                    ...config.data,
                };
            } else if (config.method == 'get') {
                data = {
                    ...data,
                    ...config.params,
                };
            }

            if (config.method == 'post') {
                config.data = data;
            } else if (config.method == 'get') {
                config.params = data;
            }
        }

        // 有的接口不需要加时间戳
        if (!config.url.includes('/sport/sportApi/findMatchOddsList')) {
            // 使用网络同步时间而不是本地时间
            // data['timestamp'] = getSyncedTime();
            data['timestamp'] = new Date().getTime();
        }
        // config.headers['sign'] = md5(
        //     formatObjectToString(
        //         {
        //             ...data,
        //             device: config.headers.device,
        //         },
        //         config.url,
        //         config.method
        //     )
        // );

        // console.log(data, '--------请求参数');
        const { sign, timestampStr, nonce } = genSign(data);
        config.headers['sign'] = sign;
        config.headers['timestamp'] = timestampStr;
        config.headers['nonce'] = nonce;
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);
let isRefreshToken = false;
let tokenExpiredArr: any[] = [];
let isQueue = false;
// Response
instance.interceptors.response.use(
    async response => {
        // NProgress.done();
        // 这里根据后台返回来设置
        if (response?.config?.url?.includes('/member/getSystemTime')) {
            isQueue = false;
        }
        //这里根据后台返回来设置
        let error = {
            message: '',
        };
        const { code, data, msg } = response.data;
        error.message = msg;

        if (code == 0) {
            return Promise.resolve(response.data);
        } else {
            const userStore = useUserStore();
            if (code === 401) {
                if (!isRefreshToken) {
                    // console.log('刷新token操作被执行', response.config.url);
                    isRefreshToken = true;
                    const refreshToken = HiCache.getCache<string>(HiStance.REFRESH_TOKEN);
                    try {
                        const res = await userStore.getRefreshToken({ refreshToken });
                        if (res?.code === 0) {
                            tokenExpiredArr.forEach((item: () => void) => item());

                            tokenExpiredArr = [];

                            isRefreshToken = false;

                            return instance({
                                ...response.config,
                                data: JSON.parse(response.config.data),
                            });
                        } else {
                            // 跳转到登录页
                            // Message.error('未授权，请重新登录')
                            isRefreshToken = false;
                            tokenExpiredArr = [];
                            userStore.clearToken();
                            setTimeout(() => (window.location.href = '/'));
                        }
                    } catch (e) {
                        isRefreshToken = false;
                        tokenExpiredArr = [];
                        userStore.clearToken();
                        setTimeout(() => (window.location.href = '/'));
                    }
                } else {
                    // tokenExpiredArr.push(response?.config)
                    return new Promise(resolve => {
                        tokenExpiredArr.push((item: () => void) => {
                            resolve(
                                instance({
                                    ...response?.config,
                                    data: JSON.parse(response?.config.data),
                                })
                            );
                        });
                    });
                }
            }

            if (code === 4005) {
                return Promise.resolve(response.data);
            }
            if (response?.config?.url?.includes('/member/login') && code === 1000) {
                return Promise.reject(response.data);
            }
            switch (
                code
                // case 40204:
                //     if (response.config.url?.includes("refreshToken")) {
                //         // await store.dispatch(UserActionsType.USER_REMOVE, '');
                //         window.location.href = '/'
                //     }
                //     break;
                // case 4005212:
                //     window.location.href = '/cookie'
                //     // await router.push('/cookie');
                //     break;
                // default:
                //     if (response.config.url?.includes("/api/member/login")) {
                //         return Promise.reject(response.data)
                //     }
                //     return Promise.reject(msg)
            ) {
            }
            return Promise.reject(error.message);
        }
    },
    async error => {
        const userStore = useUserStore();
        return Promise.reject(error.message);
    }
);

export default instance;
